/** @jsxImportSource @emotion/react */

import React from 'react';
import { css } from '@emotion/react';
import UDText from '../text';
import classNames from 'classnames';

// Modal Header
export type ModalHeaderProps = {
  title: string;
  subtitle?: string;
  className?: string;
};

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, subtitle, className }) => {
  return (
    <div className={classNames('modal-header mb-2.5', className)}>
      <UDText isNew type="title-1" className="center">
        {title}
      </UDText>
      {subtitle && (
        <UDText type="callout" className="center">
          {subtitle}
        </UDText>
      )}
    </div>
  );
};

// Modal Body
export type ModalBodyProps = {
  children: React.ReactNode;
  className?: string;
};

export const ModalBody: React.FC<ModalBodyProps> = ({ children, className }) => {
  return (
    <div className={classNames('modal-body', className)} css={modalBodyStyles}>
      {children}
    </div>
  );
};

const modalBodyStyles = () => css`
  flex: 1;
`;

// Modal Footer
export type ModalFooterProps = {
  children: React.ReactNode;
  className?: string;
  justify?: 'start' | 'center' | 'end' | 'between';
};

export const ModalFooter: React.FC<ModalFooterProps> = ({ children, className, justify = 'end' }) => {
  const justifyClass = {
    start: 'justify-content-start',
    center: 'justify-content-center',
    end: 'justify-content-end',
    between: 'justify-content-between',
  }[justify];

  return (
    <div className={classNames('modal-footer d-flex align-items-center gap-3', justifyClass, className)} css={modalFooterStyles}>
      {children}
    </div>
  );
};

const modalFooterStyles = css`
  margin-top: 40px;
  width: 100%;
`;
